import React from "react";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import Link from "../../components/Link";
import { Image } from "../../components/Image";

import * as styles from "./component.module.less";
import { generateClassString } from "../../lib/helper/generateClassString";
import t from "../../lib/translate";

function ContactPersonBlock({
    data: {
        anker,
        background,
        mediaAlignRight,
        tagline,
        semanticOfHeadline,
        headline,
        subheadline,
        contactPerson
    },
    locale,
    type
}) {
    return (
        <SectionContainer
            sectionId={anker}
            containerClass={generateClassString(styles.container, [
                mediaAlignRight,
                styles.alignRight
            ])}
            background={background}
        >
            <div className={styles.heading}>
                <header>
                    <span className={styles.tagline}>{tagline}</span>
                    <Headline semanticOfHeadline={semanticOfHeadline}>
                        {headline}
                    </Headline>
                    <StructuredTextRenderer data={subheadline} contentElementType={type} />
                </header>

                <div className={styles.contactContainer}>
                    <div className={styles.contact}>
                        <p>{contactPerson.department.country}</p>

                        <span>{contactPerson.department.name}</span>

                        <span>
                            {contactPerson.department.street}{" "}
                            {contactPerson.department.number}
                        </span>

                        <span>
                            {contactPerson.department.zip}{" "}
                            {contactPerson.department.place}
                        </span>
                    </div>

                    <div className={styles.contact}>
                        <p>{t("contact.contact.details")}</p>
                        <span>{contactPerson.department.phone}</span>
                        <span>{contactPerson.department.email}</span>
                    </div>
                </div>

                <div className={styles.buttonContainer}>
                    <Link to={locale ? `/${locale}/` : "/"}>
                        {t("contact.inquire.now")}
                    </Link>
                </div>
            </div>

            <Image imageClass={styles.media} image={contactPerson.image} />
        </SectionContainer>
    );
}

export { ContactPersonBlock }